import * as React from "react";
import { ThemeProvider } from "styled-components";

import usePage from "@/hooks/use-page";

import useTheme from "../editor/themes/use-theme";

interface Props {
  children: React.ReactNode;
}

export const StyledThemeProvider = ({ children }: Props) => {
  const { currentTheme } = useTheme();
  const pageContext = usePage();

  return (
    <ThemeProvider
      theme={{
        colors: pageContext.page.properties.colors,
        fonts: pageContext.page.properties.fonts,
        fontImports: pageContext.page.font_imports,
        typography: currentTheme.typography,
        themeKind: currentTheme.kind,
      }}
    >
      {children}
    </ThemeProvider>
  );
};
